export var Labels={paymentProcessing:"Procesamiento del pago"};